import request from "@/axios/server";

// let pefix = '/mczbapi'
let pefix = "/api";
//专家登录
export const expertLog = function (data) {
    return request({
        url: pefix + "/zbExpert/expertLog",
        method: "post",
        data,
    });
};

//专家手机号登录
export const expertPhoneLog = function (data) {
    return request({
        url: pefix + "/zbExpert/expertPhoneLog",
        method: "post",
        data,
    });
};

// 专家个人信息及履历信息不全
export const expertInformationIncomplete = function (data) {
    return request({
        url: pefix + "/zbExpert/expertInformationIncomplete",
        method: "post",
        data,
    });
};

//专家找回密码
export const expertFindPassword = function (data) {
    return request({
        url: pefix + "/zbExpert/expertFindPassword",
        method: "post",
        data,
    });
};
//注册专家账号手机号验证
export const experAccountVerify = function (data) {
    return request({
        url: pefix + "/zbExpert/experAccountVerify",
        method: "post",
        data,
    });
};

//专家注册
export const expertReg = function (data) {
    return request({
        url: pefix + "/zbExpert/expertReg",
        method: "post",
        headers: {"Content-Type": "application/json"},
        data,
    });
};
//供应商账号登录
export const supplierAccountLog = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierAccountLog",
        method: "post",
        headers: {"Content-Type": "application/json"},
        data,
    });
};

//注册供应商账号手机号验证
export const supplierAccountVerify = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierAccountVerify",
        method: "post",
        data,
    });
};

//供应商手机号登录
export const supplierPhoneLog = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierPhoneLog",
        method: "post",
        data,
    });
};

//供应商找回密码
export const supplierFindPassword = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierFindPassword",
        method: "post",
        data,
    });
};

//供应商注册
export const supplierReg = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierReg",
        method: "post",
        data,
    });
};

//手机短信验证码
export const phoneCode = function (data) {
    return request({
        url: pefix + "/captcha/phoneCode",
        method: "post",
        params: data,
    });
};

export const upload = function (data) {
    return request({
        url: pefix + "/upload",
        method: "post",
        params: data,
    });
};
// 首页轮播图接口
export const companyRotationChartPage = function (data) {
    return request({
        url: pefix + "/zbCompanyRotationChart/companyRotationChartPage",
        method: "get",
        params: data,
    });
};

// 合作伙伴分页
export const partnersPage = function (data) {
    return request({
        url: pefix + "/zbCompanyQualifications/partnersPage",
        method: "get",
        params: data,
    });
};

// 公司资质、荣誉分页
export const companyQualificationsList = function (data) {
    return request({
        url: pefix + "/zbCompanyQualifications/companyQualificationsList",
        method: "get",
        params: data,
    });
};

// 联系我们、招贤纳士、公司简介查询
export const aboutUSDetail = function (data) {
    return request({
        url: pefix + "/zbCompanyInformation/aboutUSDetail",
        method: "get",
        params: data,
    });
};

// 新闻动态
export const newsPage = function (data) {
    return request({
        url: pefix + "/zbCompanyInformation/newsPage",
        method: "get",
        params: data,
    });
};

// 公司大事记查询
export const companyMemorabiliaDetail = function (data) {
    return request({
        url: pefix + "/zbCompanyMemorabilia/companyMemorabiliaDetail",
        method: "get",
        params: data,
    });
};

// 资料下载文件分页
export const publicFile = function (data) {
    return request({
        url: pefix + "/zbPublicFile/publicFile",
        method: "get",
        params: data,
    });
};

// 招标流程图
export const companyBiddingList = function (data) {
    return request({
        url: pefix + "/zbCompanyBiddingProcess/companyBiddingProcess",
        method: "get",
        params: data,
    });
};

// 政策法规-规范性文件分页
export const policyNormativeDocumentsPage = function (data) {
    return request({
        url: pefix + "/zbPolicyNormativeDocuments/policyNormativeDocumentsPage",
        method: "get",
        params: data,
    });
};

// 政策法规、法律、行政法规分页
export const policyRegulationsPage = function (data) {
    return request({
        url: pefix + "/zbPolicyRegulations/policyRegulationsPage",
        method: "get",
        params: data,
    });
};

// 平台动态分页
export const platformDynamicsPage = function (data) {
    return request({
        url: pefix + "/zbPlatformDynamics/platformDynamicsPage",
        method: "get",
        params: data,
    });
};

// 公告公示
export const projectNoticePage = function (data) {
    return request({
        url: pefix + "/zbProjectNotice/projectNoticePage",
        method: "get",
        params: data,
    });
};

// 公告公示 -> 政府项目公告
export const newProjectNoticePage = function (data) {
    return request({
        url: pefix + "/ZbProjectGovernmentNotice/governmentNoticePage",
        method: "get",
        params: data,
    });
};

// 公司荣誉分页
export const honorList = function (data) {
    return request({
        url: pefix + "/zbCompanyQualifications/honorList",
        method: "get",
        params: data,
    });
};

// 公司资质分页
export const qualificationsList = function (data) {
    return request({
        url: pefix + "/zbCompanyQualifications/qualificationsList",
        method: "get",
        params: data,
    });
};

// 采购方式
export const procurementMethod = function (data) {
    return request({
        url: pefix + "/bladeDictBiz/procurementMethod",
        method: "get",
        params: data,
    });
};

// 浏览量
export const statisticsDetail = function (data) {
    return request({
        url: pefix + "/zbStatistics/statisticsDetail",
        method: "get",
        params: data,
    });
};
//供应商报名
export const supplierApplication = function (data) {
    return request({
        url: pefix + "/zbSupplierApplicationInformation/supplierApplication",
        method: "post",
        data,
    });
};
//项目报名-查看公告
export const lookProjectNotice = function (data) {
    return request({
        url: pefix + "/zbProjectNotice/lookProjectNotice",
        method: "post",
        data,
    });
};

//项目详情
export const getProjectDetail = function (data) {
    return request({
        url: pefix + "/zbProject/getProjectDetail",
        method: "post",
        data,
    });
};

//上传保证金支付凭证
export const supplierUploadPayVoucher = function (data) {
    return request({
        url: pefix + "/zbSupplierMargin/supplierUploadPayVoucher",
        method: "post",
        data,
    });
};

//上传招标文件费用支付凭证
export const supplierUploadPayVoucher2 = function (data) {
    return request({
        url: pefix + "/zbSupplierDocumentFees/supplierUploadPayVoucher",
        method: "post",
        data,
    });
};

//供应商报名信息详情
export const supplierApplicationDetail = function (data) {
    return request({
        url: pefix + "/zbSupplierApplicationInformation/supplierApplicationDetail",
        method: "post",
        data,
    });
};

//供应商是否报名
export const isApplication = function (data) {
    return request({
        url: pefix + "/zbSupplierProjectMap/projectIsApplication",
        method: "post",
        data,
    });
};

//供应商申请开票
export const supplierApplyInvoice = function (data) {
    return request({
        url: pefix + "/zbSupplierInvoice/supplierApplyInvoice",
        method: "post",
        data,
    });
};

// 修改密码
export const updatePassword = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierModifyPassword",
        method: "post",
        data,
    });
};

// 修改邮箱
export const updateMail = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierModifyMailbox",
        method: "post",
        data,
    });
};

// 修改手机号
export const updatePhone = function (data) {
    return request({
        url: pefix + "/zbSupplier/supplierModifyPhone",
        method: "post",
        data,
    });
};

// 供应商个人中心报名（列表）
export const applicationList = function (data) {
    return request({
        url: pefix + "/zbSupplierProjectMap/supplierProjectApplication",
        method: "get",
        params: data,
    });
};

// 质疑
export const projectFileQuestion = function (data) {
    return request({
        url: pefix + "/zbSupplierQuestion/projectFileQuestion",
        method: "post",
        data,
    });
};
// 招标文件下载
export const downloadToClient = function (data) {
    return request({
        url: pefix + "/fileDownload/downloadToClient",
        method: "get",
        params: data,
    });
};

// 供应商被邀请、已报名、中标项目（列表）
export const invitedList = function (data) {
    return request({
        url: pefix + "/zbSupplierProjectMap/supplierInviteProject",
        method: "get",
        params: data,
    });
};

// 获取所有业务字典树
export const allDictBiz = function (data) {
    return request({
        url: pefix + "/bladeDictBiz/allDictBiz",
        params: data,
    });
};
// 供应商拒绝邀请
export const supplierRefuse = function (data) {
    return request({
        url: pefix + "/zbSupplierProjectMap/supplierRefuseInviteProject",
        method: "post",
        data,
    });
};

// 已报名项目退还保证金
export const registeredRefund = function (data) {
    return request({
        url: pefix + "/zbSupplierMargin/registeredReturnMargin",
        method: "post",
        data,
    });
};

// 已中标项目退还保证金
export const winBidRefund = function (data) {
    return request({
        url: pefix + "/zbSupplierMargin/winningBidReturnMargin",
        method: "post",
        data,
    });
};

// 供应商中标通知书
export const bidWinningNoticeDetail = function (data) {
    return request({
        url: pefix + "/zbSupplierBidWinningNotice/bidWinningNoticeDetail",
        method: "post",
        data,
    });
};

// 供应商中标通知详情
export const getPreviewAddress = (params) => {
    return request({
        url: pefix + "/fileDownload/getPreviewAddress",
        method: "post",
        data: params,
    });
};

// 我的发票
export const myInvoice = function (data) {
    return request({
        url: pefix + "/zbSupplierInvoice/supplierInvoicePage",
        method: "get",
        params: data,
    });
};

// 我的质疑  // /zbSupplierQuestion/supplierQuestionPage
export const myQuestion = function (data) {
    return request({
        url: pefix + "/zbSupplierQuestion/supplierQuestionPage",
        method: "get",
        params: data,
    });
};

// 专家评标项目
export const expertProject = function (data) {
    return request({
        url: pefix + "/zbExpert/expertProject",
        method: "get",
        params: data,
    });
};

// 专家修改密码 /zbExpert/expertModifyPassword

export const expertUpdatePassword = function (data) {
    return request({
        url: pefix + "/zbExpert/expertModifyPassword",
        method: "post",
        data,
    });
};

// 专家修改手机号
export const expertUpdatePhone = function (data) {
    return request({
        url: pefix + "/zbExpert/expertModifyPhone",
        method: "post",
        data,
    });
};

// 专家个人中心账号管理
export const expertAccount = function (data) {
    return request({
        url: pefix + "/zbExpert/expertInformation",
        method: "post",
        data,
    });
};

// 专家开户行修改 /zbExpert/expertModifyBank
export const expertUpdateBank = function (data) {
    return request({
        url: pefix + "/zbExpert/expertModifyBank",
        method: "post",
        data,
    });
};

//服务费
export const serviceChargeDetail = function (data) {
    return request({
        url: pefix + "/zbSupplierMargin/getServiceChargeDetail",
        method: "get",
        params: data,
    });
};

export const specialityList = (row) => {
    return request({
        url: pefix + "/ZbExpertReviewSpeciality/list",
        method: "post",
    });
};

// /gongShangPay/pay
export const gongShangPay = (data) => {
    return request({
        url: pefix + "/gongShangPay/pay",
        method: "post",
        data,
    });
};

// /zbSupplierProjectMap/supplierInviteProject
export const supplierInviteProject = (params) => {
    return request({
        url: pefix + "/zbSupplierProjectMap/supplierInviteProject",
        method: "get",
        params,
    });
};


// updateServiceCharge
export const updateServiceCharge = (params) => {
    return request({
        url: pefix + "/zbSupplierMargin/updateServiceCharge",
        method: "get",
        params,
    });
};

// /zbSupplierDocumentFees/allDocumentFees
export const allDocumentFees = (params) => {
    return request({
        url: pefix + "/zbSupplierDocumentFees/allDocumentFees",
        method: "get",
        params,
    });
};

// /ZbProjectGovernmentBidNotice/governmentBidNoticePage
export const governmentBidNoticePage = (params) => {
    return request({
        url: pefix + '/ZbProjectGovernmentBidNotice/governmentBidNoticePage',
        method: 'get',
        params,
    })
}

// /zbProjectAbandonBid/projectSectionList
export const projectSectionList = (params) => {
    return request({
        url: pefix + '/zbProjectAbandonBid/projectSectionList',
        method: 'post',
        data: params
    })
}

export const getTableList = (params) => {
    return request({
        url: pefix + '/zbSupplierInvoice/supplierInvoiceList',
        method: 'post',
        data: params
    })
}

export const updateExpertInformation = (params) => {
    return request({
      url: pefix + 'zbExpert/updateExpertInformation',
      method: 'post',
      data: params
    })
  }